import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/leader-crown-icon.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2e4558bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  "data-test": "group-member-table"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_3 = { class: "table-responsive text-big table-padding" }
const _hoisted_4 = {
  id: "watchTable",
  class: "table table-hover"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"max-width":"0"} }),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Solo"),
    /*#__PURE__*/_createElementVNode("th", null, "Viewpoints"),
    /*#__PURE__*/_createElementVNode("th", null, "Develop"),
    /*#__PURE__*/_createElementVNode("th", null, "Team Pathway")
  ])
], -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "100",
  "data-test": "no-members-message"
}, "No members", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  style: {"max-width":"0"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "leader-icon",
  src: _imports_0,
  alt: "team lead or organisation admin",
  tabindex: "0",
  "data-test": "group-member-admin-icon"
}, null, -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "glyphicon glyphicon-plus text-muted"
}
const _hoisted_14 = {
  key: 1,
  class: "glyphicon glyphicon-minus text-muted"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 1,
  "data-test": "member-name-label"
}
const _hoisted_17 = {
  style: {"min-width":"150px"},
  class: "hidden-on-collapse"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"5px"} }, null, -1))
const _hoisted_19 = {
  key: 0,
  style: {"font-weight":"bold"}
}
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "hidden" }
const _hoisted_22 = ["data-sort"]
const _hoisted_23 = ["data-sort"]
const _hoisted_24 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_25 = {
  key: 1,
  class: "text-muted",
  "data-test": "no-pathway-progress"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["href"]
const _hoisted_30 = { style: {"min-width":"150px"} }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  style: {"display":"none"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "(pending...)")
], -1))

import { Tooltip } from "uiv";
import { triggerRef, ref } from "vue";
import TeamMemberReportLink from "./team-member-report-link.vue";
import TeamMemberDevelopLine from "./team-member-develop-line.vue";
import {
  TeamCurrentAndPendingMembersApiModel,
  TeamCurrentMemberApiModel,
  TeamMemberCompletedPathwayStepApiModel,
} from "../../api-models";
import TeamMemberPathway from "./team-member-pathway.vue";
import { csContext } from "../../services/cs-context";


export default /*#__PURE__*/_defineComponent({
  __name: 'group-member-table',
  props: {
    model: {},
    teamId: {}
  },
  setup(__props: any) {

const props = __props;

const expanded = ref<Record<string, boolean>>({});

const userId = csContext.user.id;

const isExpanded = (member: TeamCurrentMemberApiModel): boolean => {
  return !!expanded.value[member.userDetails.email];
};

const memberFullName = (member: TeamCurrentMemberApiModel): string => {
  return `${member.userDetails.firstName} ${member.userDetails.lastName}`;
};

const memberProfileCanBeViewed = (member: TeamCurrentMemberApiModel): boolean => {
  return userId === member.userDetails.id || member.isUserProfileSharedWithOrganisation;
};

const toggleMemberExpansion = (member: TeamCurrentMemberApiModel): void => {
  if (typeof expanded.value[member.userDetails.email] === "undefined") {
    expanded.value[member.userDetails.email] = false;
  }
  expanded.value[member.userDetails.email] = !expanded.value[member.userDetails.email];
  triggerRef(expanded);
};

const developDay = (member: TeamCurrentMemberApiModel): number => {
  return member.develop.currentStrengthProgress?.lastDayIndex ?? 0;
};

const pathwayProgress = (
  progress: TeamMemberCompletedPathwayStepApiModel[],
  isCurrent: boolean,
) => {
  if (isCurrent) {
    return progress.filter((p) => p.teamId === props.teamId && !p.teamPathwayIsComplete);
  }
  return progress.filter((p) => p.teamId === props.teamId);
};

return (_ctx: any,_cache: any) => {
  const _directive_data_table = _resolveDirective("data-table")!

  return (_ctx.model)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _withDirectives((_openBlock(), _createElementBlock("table", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("tbody", null, [
              (_ctx.model.currentMembers.length === 0 && _ctx.model.pendingMembers.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_6, _hoisted_8))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.currentMembers, (member) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: member.userDetails.email,
                  class: _normalizeClass(["expandable-row", { expanded: isExpanded(member) }]),
                  "data-test": "group-member-row",
                  style: {"position":"relative"}
                }, [
                  (member.isTeamOrOrgAdmin)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                        (_openBlock(), _createBlock(_unref(Tooltip), {
                          tag: "div",
                          text: "Team lead",
                          key: member.userDetails.id
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 2
                        }, 1024))
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_11)),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "showHideButton btn btn-default btn-xs",
                      style: {"margin":"-1px 0"},
                      "aria-label": "open more details",
                      onClick: ($event: any) => (toggleMemberExpansion(member)),
                      "data-test": "expand-button"
                    }, [
                      (!isExpanded(member))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14))
                    ], 8, _hoisted_12)
                  ]),
                  _createElementVNode("td", null, [
                    (memberProfileCanBeViewed(member))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: `/user/profile/${member.userDetails.id}`,
                          "data-test": "member-name-link"
                        }, _toDisplayString(memberFullName(member)), 9, _hoisted_15))
                      : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(memberFullName(member)), 1)),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      (member.userDetails.email)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("a", {
                              href: 'mailto:' + member.userDetails.email,
                              target: "_blank",
                              rel: "noopener noreferrer"
                            }, _toDisplayString(member.userDetails.email), 9, _hoisted_20)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(member.solo.linkSortPrefix), 1),
                    _createVNode(TeamMemberReportLink, {
                      link: member.solo.activeReport
                    }, null, 8, ["link"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.solo.otherReports, (report, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "hidden-on-collapse"
                      }, [
                        _createVNode(TeamMemberReportLink, { link: report }, null, 8, ["link"])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("td", {
                    "data-sort": member.viewpoints.subReports.length,
                    "data-test": "viewpoints-links"
                  }, [
                    _createVNode(TeamMemberReportLink, {
                      link: member.viewpoints.activeReport
                    }, null, 8, ["link"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.viewpoints.subReports, (respondent, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "hidden-on-collapse"
                      }, [
                        _createVNode(TeamMemberReportLink, { link: respondent }, null, 8, ["link"])
                      ]))
                    }), 128))
                  ], 8, _hoisted_22),
                  _createElementVNode("td", {
                    "data-sort": developDay(member)
                  }, [
                    (
                  member.develop &&
                  member.develop.currentStrengthProgress &&
                  member.develop.currentStrengthProgress.strengthItemId
                )
                      ? (_openBlock(), _createBlock(TeamMemberDevelopLine, {
                          key: 0,
                          model: member.develop.currentStrengthProgress
                        }, null, 8, ["model"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_24, "no develop")),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.develop.otherProgress, (otherProgress, index) => {
                      return (_openBlock(), _createBlock(TeamMemberDevelopLine, {
                        key: index,
                        model: otherProgress,
                        class: "hidden-on-collapse"
                      }, null, 8, ["model"]))
                    }), 128))
                  ], 8, _hoisted_23),
                  _createElementVNode("td", null, [
                    (pathwayProgress(member.pathways.currentPathwaysInProgress, true).length > 0)
                      ? (_openBlock(), _createBlock(TeamMemberPathway, {
                          key: 0,
                          model: pathwayProgress(member.pathways.currentPathwaysInProgress, true)[0],
                          isCurrentPathway: true
                        }, null, 8, ["model"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_25, "no progress")),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pathwayProgress(
                  member.pathways.otherProgress,
                  false,
                ), (otherProgress, index) => {
                      return (_openBlock(), _createBlock(TeamMemberPathway, {
                        key: index,
                        model: otherProgress,
                        isCurrentPathway: false,
                        class: "hidden-on-collapse",
                        "data-test": "other-pathway-progress"
                      }, null, 8, ["model"]))
                    }), 128))
                  ])
                ], 2))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.pendingMembers, (pending) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: pending.userId
                }, [
                  _hoisted_26,
                  _hoisted_27,
                  _createElementVNode("td", null, [
                    (!!pending.firstName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(pending.firstName), 1))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: 'mailto:' + pending.email
                        }, _toDisplayString(pending.email), 9, _hoisted_29))
                  ]),
                  _createElementVNode("td", _hoisted_30, [
                    (!!pending.lastName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(pending.lastName), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_32, "ZZZZ"))
                  ]),
                  _hoisted_33,
                  _hoisted_34,
                  _hoisted_35
                ]))
              }), 128))
            ])
          ])), [
            [_directive_data_table, 
          _ctx.model.currentMembers.length && {
            paging: false,
            searching: false,
            info: false,
            columnDefs: [{ targets: 0, orderable: false }],
            order: [
              [2, 'asc'],
              [1, 'asc'],
            ],
          }
        ]
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})